export default [
  { label: "Soltero/a", value: "0" },
  { label: "Casado/a", value: "1" },
  { label: "Divorciado/a", value: "3" },
  { label: "Unión libre", value: "4" },
];
